import { ButtonColors } from 'types';
import { Icon } from 'components/icon';
import { Button } from 'components/button';
import { Dialog } from 'components/dialog';
import { CartItem } from 'store/api/cart/types';
import imagePlaceholder from 'assets/images/no-image-placeholder.jpg';

import * as Styles from './styles';
import {
  FormValuesProduct,
  ShipmentSummaryLine,
  ShipmentSummaryProps,
} from './types';

// Splits the cart into what ships and what the customer takes home now, so
// the rep can read both lists back before the address step (owner 24 Oct 2026).
export const getShipmentSummary = (
  products: FormValuesProduct[],
  cartItems: CartItem[] = []
) => {
  const shipped: ShipmentSummaryLine[] = products.map((product) => ({
    id: product.id,
    name: product.name,
    photoUrl: product.photoUrl,
    quantity: +product.quantity,
  }));

  const takeHome = cartItems
    .filter((item) => !item.isExchange)
    .map((item) => {
      const shippedQuantity =
        shipped.find((line) => line.id === item.id)?.quantity ?? 0;
      return {
        id: item.id,
        name: item.product?.name,
        photoUrl: item.product?.photoUrl,
        quantity: item.quantity - shippedQuantity,
      };
    })
    .filter((line) => line.quantity > 0);

  return { shipped, takeHome };
};

const Lines = ({ lines }: { lines: ShipmentSummaryLine[] }) => (
  <>
    {lines.map((line) => (
      <Styles.SummaryLine key={line.id}>
        <Styles.SummaryImage
          width={40}
          height={40}
          objectFit="cover"
          src={line.photoUrl || imagePlaceholder}
        />
        <Styles.SummaryName>{line.name}</Styles.SummaryName>
        <Styles.SummaryQuantity>× {line.quantity}</Styles.SummaryQuantity>
      </Styles.SummaryLine>
    ))}
  </>
);

export const ShipmentSummary = ({
  open,
  onBack,
  products,
  onConfirm,
  cartItems,
  afterSale,
}: ShipmentSummaryProps) => {
  const { shipped, takeHome } = getShipmentSummary(products, cartItems);

  return (
    <Dialog
      open={open}
      width="560px"
      showCloseButton
      onClose={onBack}
      title="Check the shipment"
      closeOnDocumentClick={false}
    >
      {(close) => (
        <>
          <Styles.SummaryText>
            Read both lists to the customer before you continue.
          </Styles.SummaryText>

          <Styles.SummarySection $shipping>
            <Styles.SummaryHeading $shipping>
              <Icon.Delivery />
              Shipping to the customer
            </Styles.SummaryHeading>
            <Lines lines={shipped} />
          </Styles.SummarySection>

          <Styles.SummarySection>
            <Styles.SummaryHeading>
              {afterSale ? 'Not shipped' : 'Taking home now (not shipped)'}
            </Styles.SummaryHeading>
            {takeHome.length ? (
              <Lines lines={takeHome} />
            ) : (
              <Styles.SummaryName>
                Nothing, every item is shipped
              </Styles.SummaryName>
            )}
          </Styles.SummarySection>

          <Styles.SummaryButtons>
            <Button
              fullWidth
              onClick={close}
              text="Back, change items"
              colorType={ButtonColors.LightBlue}
            />
            <Button
              fullWidth
              onClick={onConfirm}
              text="Correct, continue"
              colorType={ButtonColors.Blue}
            />
          </Styles.SummaryButtons>
        </>
      )}
    </Dialog>
  );
};
